import React from "react";
import t, { changeLanguage } from "../../components/I18N/TranslateHelpers";
import { GetCurrentLocale } from "../../components/Utils";
import { useSelector } from "react-redux";
import { RootState } from "../../app/RootReducer";

interface ComponentProps{
  itemsInCart: any,
  activeStep: number
}

const CartSummaryTotal: React.FC<ComponentProps> = ({ itemsInCart, activeStep }) => {
  const locale = GetCurrentLocale();
  changeLanguage(locale);

  const userCatalogs = useSelector((state: RootState) => state.userRdc.userCatalog);

  // Méthode pour déterminer si le prix doit être caché pour un produit donné
  const shouldHidePriceForProduct = (productId: number, catalogs: any[]): boolean => {
    if (!catalogs || catalogs.length === 0) return false;
    const catalogsWithProduct = catalogs.filter((catalog: any) =>
      catalog.products?.some((p: any) => p.id === productId)
    );
    if (catalogsWithProduct.length === 0) return false;
    return catalogsWithProduct.every((c: any) => c.hidePrices === true);
  };

  // Filtrage des produits du panier dont le prix est visible
  const visibleItems = itemsInCart?.items?.filter((item: any) => {
    const productId = item.product?.id ?? item.variant?.product?.id;
    return !shouldHidePriceForProduct(productId, userCatalogs);
  }) ?? [];

  // Calcul du sous-total des produits visibles
  const subTotal = visibleItems.reduce((sum: number, item: any) => {
    const unitPrice = item.discountedUnitPrice ?? item.originalUnitPrice;
    return sum + unitPrice * item.quantity;
  }, 0);

  // Calcul des autres montants (TVA, promotions, total)
  const taxTotal = 0;
  const promoTotal = 0;
  const total = subTotal + taxTotal;

  // Affichage du résumé du panier
  return (
    <div className="row gy-3 mb-4 align-items-center">
      <div className="aside">
        <div className={activeStep > 0 ? "col-lg-6 float-end" : "col-lg-4 col-sm-6 float-end"}>
          <hr />
          <h6 className="card-title">{t('summary_cart')}</h6>

          {promoTotal !== 0 && (
            <dl className="dlist-align">
              <dt>{t('reduction')} :</dt>
              <dd className="text-end text-danger">{(promoTotal / 100).toFixed(2)} €</dd>
            </dl>
          )}

          <dl className="dlist-align">
            <dt>{t('sub_total')} :</dt>
            <dd className="text-end">{(subTotal / 100).toFixed(2)} €</dd>
          </dl>
          <dl className="dlist-align">
            <dt>{t('tax_total')} :</dt>
            <dd className="text-end">{(taxTotal / 100).toFixed(2)} €</dd>
          </dl>
          <dl className="dlist-align">
            <dt>{t('total')} :</dt>
            <dd className="text-end">{(total / 100).toFixed(2)} €</dd>
          </dl>
        </div>
      </div>
    </div>
  );
};
export default CartSummaryTotal;

